import { render, staticRenderFns } from "./VolumeBySource.vue?vue&type=template&id=4c38c0e3"
import script from "./VolumeBySource.vue?vue&type=script&lang=js"
export * from "./VolumeBySource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports